import React 						from 'react';
import ReactDOM 					from 'react-dom';
import ReactJson					from 'react-json-view';
import BLComponent					from '../../core/_BLComponent.jsx';
import Modal 						from '../../modals/_DynamicModal.jsx';

import AddItemModalBody				from './_AddItemModalBody.jsx';

export default class SaveAddItemResModal extends BLComponent 
{
	constructor ( props, context )
	{
		super( props, context );	// This should come first. 

		this.state	= 	{};
	}

	render()
	{
		return (
			<div>
			{this.renderModal()}</div>
		)
	}

	renderModal() {
		const itemType = this.props.data.itemType;
		const addItemModalBody = () => {
			return (
				<AddItemModalBody data={this.props.data} />
			)
		}

		const modalOption = {
			title: { name: "", showClose: true, display: false, clickable: true, callback:()=>{return null} }
		,	showCloseButton: true
		,	closeOnEscape: true
		,	modalSize: "s" /* s m l */
		,	ModalBody: addItemModalBody
		,	modal_allscreen: true
		,	ModalFooter: {
				buttons: {
					direction: "row"
				,	list: []
				}
			,	dontshowagain: { msg:"Don't show again", display: false, func:()=>{return null}}
			}
		,	closeFunc: ()=>this.toggleModal()
		}

		return (
			<Modal data={ modalOption }/>
		)
	}

	toggleModal() {
		this.props.func.closeAddItemResModal();
	}

};

